export function setCookie(name, value, days) {
  let expires = "";
  
  if (days) {
      let date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "expires=" + date.toUTCString();
  } else if (days < 0) {
      // 明确设置为过去的日期以删除 cookie
      expires = "expires=Thu, 01 Jan 1970 00:00:00 GMT";
  }
  
  document.cookie = name + "=" + value + ";" + expires + ";domain=.kdslife.com;path=/";
}